module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.6209a44bd045724a4e6f.js");
};